<?xml version="1.0" encoding="UTF-8"?>
<svg id="ICONS" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
  <path d="m6.63379,4.92188H1.36621c-.50879,0-.92188-.41309-.92188-.92188s.41309-.92188.92188-.92188h5.26758c.50879,0,.92188.41309.92188.92188s-.41309.92188-.92188.92188Z" fill="var(--iconPrimary, #222)" stroke-width="0"/>
</svg>